var _mask, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSettingAdvertisement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_436_46674",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3837 16.6345L6.21379 15.8784C4.39287 15.7099 3 14.1822 3 12.3535V10.1854C3 8.35668 4.39287 6.82896 6.21379 6.66044L13.9344 5.94595L18.249 3.27299C19.4495 2.52931 21 3.39271 21 4.80486V16.9968C21 18.3316 19.5994 19.2031 18.4019 18.6133L14.3837 16.6345Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3837 16.6345L15.1171 15.1453L14.842 15.0098L14.5367 14.9815L14.3837 16.6345ZM6.21379 15.8784L6.36676 14.2255H6.36676L6.21379 15.8784ZM6.21379 6.66044L6.36676 8.31338H6.36676L6.21379 6.66044ZM13.9344 5.94595L14.0873 7.59888L14.4764 7.56288L14.8086 7.3571L13.9344 5.94595ZM18.249 3.27299L17.3748 1.86184L17.3748 1.86184L18.249 3.27299ZM18.4019 18.6133L17.6685 20.1026H17.6685L18.4019 18.6133ZM14.5367 14.9815L6.36676 14.2255L6.06082 17.5313L14.2307 18.2874L14.5367 14.9815ZM6.36676 14.2255C5.39972 14.136 4.66 13.3246 4.66 12.3535H1.34C1.34 15.0397 3.38603 17.2838 6.06082 17.5313L6.36676 14.2255ZM4.66 12.3535V10.1854H1.34V12.3535H4.66ZM4.66 10.1854C4.66 9.21421 5.39972 8.40287 6.36676 8.31338L6.06082 5.00751C3.38602 5.25504 1.34 7.49916 1.34 10.1854H4.66ZM6.36676 8.31338L14.0873 7.59888L13.7814 4.29301L6.06082 5.00751L6.36676 8.31338ZM14.8086 7.3571L19.1232 4.68415L17.3748 1.86184L13.0601 4.53479L14.8086 7.3571ZM19.1232 4.68415C19.1587 4.66218 19.1802 4.66007 19.1936 4.66C19.2125 4.65991 19.239 4.66512 19.2671 4.6808C19.2953 4.69647 19.3136 4.7162 19.3235 4.73231C19.3305 4.74376 19.34 4.76314 19.34 4.80486H22.66C22.66 2.09184 19.6811 0.433075 17.3748 1.86184L19.1232 4.68415ZM19.34 4.80486V16.9968H22.66V4.80486H19.34ZM19.34 16.9968C19.34 17.034 19.3317 17.0535 19.3244 17.0663C19.3149 17.0827 19.2981 17.1018 19.273 17.1173C19.248 17.1329 19.2235 17.1396 19.2046 17.1408C19.1899 17.1418 19.1687 17.1406 19.1353 17.1241L17.6685 20.1026C19.9691 21.2356 22.66 19.5612 22.66 16.9968H19.34ZM19.1353 17.1241L15.1171 15.1453L13.6503 18.1237L17.6685 20.1026L19.1353 17.1241Z",
    fill: "#2E2E30",
    mask: "url(#path-1-inside-1_436_46674)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.85498L14 15.9101",
    stroke: "#2E2E30",
    strokeWidth: 1.66
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23535 7.5625L7.23535 15.4099",
    stroke: "#2E2E30",
    strokeWidth: 1.66
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15V19.75C7 20.4404 7.55964 21 8.25 21V21C8.94036 21 9.5 20.4404 9.5 19.75V15",
    stroke: "#2E2E30",
    strokeWidth: 1.66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSettingAdvertisement);
export default __webpack_public_path__ + "static/media/ic_setting_advertisement.e2c8c9298a6b126c7e8fa059a7cb53c5.svg";
export { ForwardRef as ReactComponent };